(function () {
  // --- Config ---
  // Cambia este valor si quieres medir ROAS por Lead.
  // Si lo dejas en 0, desaparece el warning de currency pero tu ROAS por Lead quedara en 0.
  var LEAD_VALUE = 0;

  // Endpoint de tu Cloudflare Worker (CAPI). Si ya lo defines en otro lugar, usa esa variable.
  var WORKER_URL = (window.HP_META_LEAD_CAPI_ENDPOINT && String(window.HP_META_LEAD_CAPI_ENDPOINT)) ||
    "https://health-and-paws.ancient-surf-4570.workers.dev/";

  // Evita disparos duplicados en la misma pagina
  var fired = false;

  function getCurrency() {
    try {
      var c = null;
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        c = window.Shopify.currency.active;
      } else if (window.Shopify && window.Shopify.currency && typeof window.Shopify.currency === "string") {
        c = window.Shopify.currency;
      }
      if (c && typeof c === "string") return c.toUpperCase();
    } catch (e) {}
    return "USD";
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\\[\\]\\\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : "";
  }

  function randomId(len) {
    len = len || 8;
    var chars = "abcdefghijklmnopqrstuvwxyz0123456789";
    var out = "";
    for (var i = 0; i < len; i++) out += chars.charAt(Math.floor(Math.random() * chars.length));
    return out;
  }

  function buildEventId() {
    return "klv-" + Date.now() + "-" + randomId(8);
  }

  function normEmail(email) {
    return (email || "").trim().toLowerCase();
  }

  async function sha256Hex(str) {
    var data = new TextEncoder().encode(str);
    var hash = await crypto.subtle.digest("SHA-256", data);
    return Array.from(new Uint8Array(hash))
      .map(function (b) { return b.toString(16).padStart(2, "0"); })
      .join("");
  }

  function getEmailFromKlaviyoEvent(e) {
    try {
      // Intentos comunes (pueden variar por version)
      var d = e && e.detail ? e.detail : null;
      if (!d) return "";
      return (
        d.email ||
        (d.data && d.data.email) ||
        (d.formData && d.formData.email) ||
        ""
      );
    } catch (err) {
      return "";
    }
  }

  function getEmailFromDOMFallback() {
    // Busca un input email con valor (Klaviyo forms suelen inyectarse en DOM)
    var input = document.querySelector('input[type="email"]:not([disabled])');
    if (input && input.value) return input.value;

    input = document.querySelector('input[name*="email" i]:not([disabled])');
    if (input && input.value) return input.value;

    return "";
  }

  async function sendServerLead(payload) {
    if (!WORKER_URL || typeof WORKER_URL !== "string") return;

    try {
      await fetch(WORKER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });
    } catch (e) {
      // Silencioso: no romper UX
    }
  }

  function sendBrowserLead(params, eventId) {
    if (typeof window.fbq !== "function") return;
    try {
      window.fbq("track", "Lead", params, { eventID: eventId });
    } catch (e) {}
  }

  async function fireLead(e) {
    var detail = e && e.detail ? e.detail : {};

    var formId = (detail && detail.formId) ? String(detail.formId) : "";
    var eventId = buildEventId();
    var currency = getCurrency();

    // --- Browser (Pixel) ---
    var browserParams = {
      source: "klaviyo",
      form_id: formId,
      value: Number(LEAD_VALUE) || 0,
      currency: currency
    };
    sendBrowserLead(browserParams, eventId);

    // --- Server (CAPI via Worker) ---
    var fbp = getCookie("_fbp");
    var fbc = getCookie("_fbc");

    var emailRaw = getEmailFromKlaviyoEvent(e) || getEmailFromDOMFallback();
    var emailNorm = normEmail(emailRaw);

    var userData = {
      fbp: fbp,
      fbc: fbc
    };

    if (emailNorm) {
      try {
        userData.em = await sha256Hex(emailNorm);
      } catch (err) {}
    }

    var payload = {
      event_name: "Lead",
      event_time: Math.floor(Date.now() / 1000),
      event_id: eventId,
      event_source_url: window.location.href,
      custom_data: {
        source: "klaviyo",
        form_id: formId,
        value: Number(LEAD_VALUE) || 0,
        currency: currency
      },
      user_data: userData
    };

    await sendServerLead(payload);
  }

  window.addEventListener("klaviyoForms", function (e) {
    if (!e || !e.detail) return;

    // Solo cuando Klaviyo confirma el envio (suscripcion)
    if (e.detail.type !== "submit") return;

    // Dedupe basico por pagina (evita dobles en re-renders)
    if (fired) return;
    fired = true;

    // Ejecuta (browser + server)
    fireLead(e);
  });
})();
